import { render, staticRenderFns } from "./ImgHolder.vue?vue&type=template&id=e4fd2ece&scoped=true&"
import script from "./ImgHolder.vue?vue&type=script&lang=js&"
export * from "./ImgHolder.vue?vue&type=script&lang=js&"
import style0 from "./ImgHolder.vue?vue&type=style&index=0&id=e4fd2ece&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4fd2ece",
  null
  
)

export default component.exports